import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import { Card, CardBody, CardHeader, Col, ListGroupItem, Row } from 'reactstrap';

import zonesSvg from '../../../../../../../../../assets/custom/v2/total-zones.svg';
import clientSvg from '../../../../../../../../../assets/custom/v2/total-clients.svg';
import configureSvg from '../../../../../../../../../assets/custom/v2/configure-pricing.svg';
import vendorSvg from '../../../../../../../../../assets/custom/v2/total-vendors.svg';
import queryString from 'query-string';

const QuickLinkCard = () => {
  const history = useHistory();

  const quickLinks = [
    {
      icon: configureSvg,
      label: 'Configure Pricing',
    },
    {
      icon: zonesSvg,
      label: 'Create Zone',
      name: 'zones_inventory_card',
      nextNavigation: 'listing_page',
      title: 'Zone List',
      type: 'inventory_card',
    },
    {
      icon: vendorSvg,
      label: 'Add Vendor',
      name: 'vendors_inventory_card',
      nextNavigation: 'listing_page',
      title: 'Vendor List',
      type: 'inventory_card',
    },
    {
      icon: clientSvg,
      label: 'Add Client',
      name: 'clients_inventory_card',
      nextNavigation: 'listing_page',
      title: 'Client List',
      type: 'inventory_card',
    },
  ];

  const routeHandler = item => {
    if (item?.nextNavigation) {
      const params = {
        name: item?.name,
        type: item?.type,
        nextNavigation: item?.nextNavigation,
        title: item?.title,
      };
      history.push({
        pathname: '/v2/inventory-list',
        search: `?${queryString.stringify(params)}`,
      });
    } else history.push(`/v2/program-onboarding`);
  };

  return (
    <Col xl={4} md={8} lg={4} className="mb-2">
      <Card className="rounded-3 quick-link-configuration-card">
        <CardHeader className="border-bottom-0">
          {' '}
          <p className="mb-0 fs-14 fw-semibold">Quick Links</p>
        </CardHeader>
        <CardBody style={{ boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.03) !important' }}>
          {quickLinks.map((link, idx) => (
            <ListGroupItem
              key={idx}
              className="d-flex justify-content-between align-items-center border-0 mb-2 rounded-3 cursor-pointer"
              style={{ background: '#fff', boxShadow: '4px 4px 18px -5px rgba(218, 221, 232, 0.8)' }}
              onClick={() => routeHandler(link)}
            >
              <Row className="align-items-center w-100">
                <Col xs="auto">
                  <img src={link.icon} alt={link.label} className="img-fluid" style={{ width: '40px', height: '40px' }} />
                </Col>
                <Col>
                  <span className="fw-medium">{link.label}</span>
                </Col>
                <Col xs="auto">
                  <FiChevronRight />
                </Col>
              </Row>
            </ListGroupItem>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default QuickLinkCard;
